export default __webpack_public_path__ + "static/media/location_preview_shrink_ray.1f0f732e.svg";